import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import WhiteContainer from './white-container';
import { styles } from './white-container.styles';

export default compose(withStyles(styles))(WhiteContainer);
